import { Dispatch } from 'react';
import { upsertStatistics, getStatistics } from '../../api/statsApi';
import {
  GameStatistics,
  IDayStatistic,
  IGameStatistics,
  IStatistics,
  StatisticsOption,
} from '../../types';
import { StatsAction, statsAcionType } from '../type';

export const fetchUpdateStats = async (id: string, statisticsData: IStatistics) => {
  await upsertStatistics(id, statisticsData)
    .then((response) => {
      response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const fetchGetUserStatistics =
  (userId: string | null, option: StatisticsOption, currGameStats?: GameStatistics) =>
  async (dispatch: Dispatch<StatsAction>) => {
    if (!userId) return;
    const currentDay = new Date();
    const date: keyof IDayStatistic = new Intl.DateTimeFormat('en-GB').format(currentDay);

    try {
      await getStatistics(userId)
        .then((response) => {
          const { id, ...userStatistics } = response.data;
          dispatch({ type: statsAcionType.UPDATE_USER_STATS_SUCCESS, payload: response.data });
          if (!userStatistics.optional[date]) {
            const DEFAULT_DAY_STATISTICS: IGameStatistics = {
              audio: { right: 0, wrong: 0, new: 0, strike: 0, learned: 0 },
              sprint: { right: 0, wrong: 0, new: 0, strike: 0, learned: 0 },
              textbook: 0,
            };
            const currDay: IDayStatistic = { [date]: DEFAULT_DAY_STATISTICS };
            userStatistics.optional = { ...userStatistics.optional, ...currDay };
          }

          if (currGameStats) {
            updateStatisticsData(userId, option, userStatistics, date, currGameStats);
          } else {
            updateStatisticsData(userId, option, userStatistics, date);
          }
        })
        .catch((err) => {
          if (err.response.status == 404) {
            const DEFAULT_STATISTICS: IStatistics = {
              learnedWords: 0,
              optional: {},
            };
            const DEFAULT_DAY_STATISTICS: IGameStatistics = {
              audio: { right: 0, wrong: 0, new: 0, strike: 0, learned: 0 },
              sprint: { right: 0, wrong: 0, new: 0, strike: 0, learned: 0 },
              textbook: 0,
            };
            const newStatistics = { ...DEFAULT_STATISTICS };
            const currDay: IDayStatistic = { [date]: DEFAULT_DAY_STATISTICS };
            newStatistics.optional = currDay;

            if (currGameStats) {
              updateStatisticsData(userId, option, newStatistics, date, currGameStats);
            } else {
              return updateStatisticsData(userId, option, newStatistics, date);
            }
          }
        });
    } catch (err) {}
  };

export const updateStatisticsData = (
  userId: string,
  option: StatisticsOption,
  userStatistics: IStatistics,
  date: string,
  currGameStatistics?: GameStatistics
) => {
  const statistics = { ...userStatistics };
  switch (option) {
    case StatisticsOption.TEXTBOOK: {
      statistics.learnedWords += 1;
      statistics.optional[date].textbook += 1;
      break;
    }
    case StatisticsOption.SPRINT: {
      if (!currGameStatistics) return;
      statistics.learnedWords += currGameStatistics.learned;
      statistics.optional[date].sprint.wrong += currGameStatistics.wrong;
      statistics.optional[date].sprint.right += currGameStatistics.right;
      statistics.optional[date].sprint.new += currGameStatistics.new;
      statistics.optional[date].sprint.learned += currGameStatistics.learned;
      statistics.optional[date].sprint.strike = Math.max(
        currGameStatistics.strike,
        statistics.optional[date].sprint.strike
      );
      break;
    }
    case StatisticsOption.AUDIO: {
      if (!currGameStatistics) return;
      statistics.learnedWords += currGameStatistics.learned;
      statistics.optional[date].audio.wrong += currGameStatistics.wrong;
      statistics.optional[date].audio.right += currGameStatistics.right;
      statistics.optional[date].audio.new += currGameStatistics.new;
      statistics.optional[date].audio.learned += currGameStatistics.learned;
      statistics.optional[date].audio.strike = Math.max(
        currGameStatistics.strike,
        statistics.optional[date].audio.strike
      );
      break;
    }
  }

  return fetchUpdateStats(userId, statistics);
};

export const fetchGetDatStats = (id: string) => async (dispatch: Dispatch<StatsAction>) => {
  const currentDay = new Date();
  const date: keyof IDayStatistic = new Intl.DateTimeFormat('en-GB').format(currentDay);
  await getStatistics(id)
    .then((response) => {
      const { id, ...userStats } = response.data;
      dispatch({ type: statsAcionType.UPDATE_USER_STATS_SUCCESS, payload: response.data });

      if (!userStats.optional[date]) {
        const DEFAULT_DAY_STATISTICS: IGameStatistics = {
          audio: { right: 0, wrong: 0, new: 0, strike: 0, learned: 0 },
          sprint: { right: 0, wrong: 0, new: 0, strike: 0, learned: 0 },
          textbook: 0,
        };
        const currDay: IDayStatistic = { [date]: DEFAULT_DAY_STATISTICS };
        userStats.optional = { ...userStats.optional, ...currDay };
      }
      fetchUpdateStats(id, userStats);
      // dispatch({ type: statsAcionType.UPDATE_USER_STATS_SUCCESS, payload: response.data });
    })
    .catch((error) => {
      if (error.response.status === 404) {
        const DEFAULT_STATISTICS: IStatistics = {
          learnedWords: 0,
          optional: {},
        };
        const DEFAULT_DAY_STATISTICS: IGameStatistics = {
          audio: { right: 0, wrong: 0, new: 0, strike: 0, learned: 0 },
          sprint: { right: 0, wrong: 0, new: 0, strike: 0, learned: 0 },
          textbook: 0,
        };
        const newStatistics = { ...DEFAULT_STATISTICS };
        const currDay: IDayStatistic = { [date]: DEFAULT_DAY_STATISTICS };
        newStatistics.optional = currDay;
        fetchUpdateStats(id, newStatistics);
      }
    });
};
